import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Header from "../../components/Header/Header";
import youtube from "../../resources/youtube.png";
import aboutUs from "../../resources/aboutUs.png";

const useStyles = makeStyles((theme) => ({
  root: {},
  AboutUs__second: {
    height: "550px",
    width: "80%",
    background: "#C4C4C4",
  },
  AboutUs__first: {
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "33px",
    color: "#000000",
  },
  AboutUs_title: {
    width: "146px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "33px",
    lineHeight: "39px",
    color: "#000000",
    marginBottom: "24px",
  },
  AboutUs_dash: {
    display: "block",
    width: "104px",
    height: "2px",
    background: "#F53838",
    marginBottom: "50px",
  },
  AboutUs_span: {
    color: "#F53838",
  },
  AboutUs_h4: {
    width: "275px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "48px",
    color: "#000000",
    marginBottom: "50px",
  },
  AboutUs_h6: {
    width: "455px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "30px",
    color: "#000000",
    lineHeight: "36px",
    marginBottom: "44px",
  },
  AboutUs_p: {
    width: "484px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontSize: "24px",
    color: "#000000",
    lineHeight: "28px",
  },
  customHeight: {
    minHeight: "655px",
  },
  [theme.breakpoints.down("md")]: {
    center: {
      marginTop: "20px",
      alignItems: "center",
    },
  },
}));

function AboutUs() {
  const classes = useStyles();

  return (
    <>
      <Container>
        <Grid container direction="column" alignItems="center" justify="center">
          <Grid
            item
            container
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Typography variant="h2" className={classes.AboutUs_title}>
              About <span className={classes.AboutUs_span}>Us</span>
            </Typography>
            <span className={classes.AboutUs_dash}></span>
          </Grid>
          <Grid
            item
            container
            alignItems="center"
            justify="center"
            className={classes.AboutUs__second}
          >
            <img src={youtube} />
          </Grid>
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center"
              className={classes.customHeight}
            >
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                container
                direction="column"
                alignItems="flex-start"
                justify="center"
                className={classes.center}
              >
                <Typography variant="h4" className={classes.AboutUs_h4}>
                  Our <span className={classes.AboutUs_span}>Mission</span>
                </Typography>

                <Typography variant="h6" className={classes.AboutUs_h6}>
                  To make you shine on a national and international level
                </Typography>

                <Typography variant="p" className={classes.AboutUs_p}>
                  With us, you are guaranteed the publication of articles in the
                  most influential media!
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                container
                alignItems="center"
                justify="center"
              >
                <img src={aboutUs} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default AboutUs;
